import { CartItem, Product } from "../types/types";

export class CartService {
  private readonly STORAGE_KEY = 'cart';

  public addToCart(product: Product, quantity: number = 1): void {
    const cart = this.getCart();
    const existingItem = cart.find(item => item.productId === product.id);

    if (existingItem) {
      existingItem.quantity += quantity;
    } else {
      cart.push({
        ...product,
        quantity: quantity,
        productId: product.id,
      });
    }

    this.saveCart(cart);
  }

  public removeFromCart(productId: string): void {
    const cart = this.getCart();
    const updatedCart = cart.filter(item => item.productId !== productId);
    this.saveCart(updatedCart);
  }

  public updateQuantity(productId: string, quantity: number): void {
    const cart = this.getCart();
    const item = cart.find(item => item.productId === productId);
    
    if (item) {
      if (quantity <= 0) {
        this.removeFromCart(productId);
      } else {
        item.quantity = quantity;
        this.saveCart(cart);
      }
    }
  }

  public getCart(): CartItem[] {
    const cartJson = localStorage.getItem(this.STORAGE_KEY);
    return cartJson ? JSON.parse(cartJson) : [];
  }

  public clearCart(): void {
    localStorage.removeItem(this.STORAGE_KEY);
  }

  public getTotal(): number {
    return this.getCart().reduce((total, item) => total + (item.price * item.quantity), 0);
  }

  private saveCart(cart: CartItem[]): void {
    localStorage.setItem(this.STORAGE_KEY, JSON.stringify(cart));
  }
}

